import { useRatingZoneSources } from '../../../components/sharedComponents/hooks';
import { useFormOptions } from '../../../hooks';
import { useCompanies } from '../../companies/hooks';
import { useInsuranceTypes } from '../../configurationInsuranceTypes';
import { useInvoicingScheduleOptions } from '../../invoice/hooks';
import { usePricingRateTypes, useProrateSettings } from '../../pricing/hooks';
import { BILLING_RULE_OPTIONS } from '../../product/utils';

export default function useProductCreateUpdateFormOptions() {
  const { options: pricingRateOptions, loading: loadingPricingRateOptions } = usePricingRateTypes();
  const { options: insuranceTypesOptions, loading: loadingInsuranceTypes } = useInsuranceTypes();
  const { options: companiesOptions, loading: loadingCompaniesOptions } = useCompanies();
  const { options: invoicingScheduleOptions } = useInvoicingScheduleOptions();
  const { options: ratingZoneSourceOptions } = useRatingZoneSources();
  const {
    options: prorateSettingsOptions,
    CATEGORIES: { WEEKLY, MONTHLY }
  } = useProrateSettings();

  const formOptions = useFormOptions({
    options: [
      { name: 'pricingRate', options: pricingRateOptions, loading: loadingPricingRateOptions },
      { name: 'insuranceTypes', options: insuranceTypesOptions, loading: loadingInsuranceTypes },
      { name: 'companies', options: companiesOptions, loading: loadingCompaniesOptions },
      { name: 'proratingSettings', options: prorateSettingsOptions },
      { name: 'proratingWeekly', options: prorateSettingsOptions?.filter(x => x.category === WEEKLY) },
      { name: 'proratingMonthly', options: prorateSettingsOptions?.filter(x => x.category === MONTHLY) },
      { name: 'invoicingSchedule', options: invoicingScheduleOptions },
      { name: 'billingRule', options: BILLING_RULE_OPTIONS },
      { name: 'ratingZoneSource', options: ratingZoneSourceOptions }
    ]
  });

  return { formOptions };
}
